(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mellow-chain-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mellow-chain-picker')) {
    customElements.define('mellow-chain-picker', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        this.trigger = this.querySelector('[data-chain-open]');
        this.sourceSection = this.closest('[data-section-type="product"]');
        this.trigger.addEventListener('click', () => this.open(), { signal: this.events.signal });
        this.sourceSection?.addEventListener('theme:variant:change', event => {
          this.charmVariant = event.detail?.variant;
          this.updateCharmImage();
        }, { signal: this.events.signal });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.dialog?.close();
        this.dialog?.remove();
        document.documentElement.classList.remove('mellow-chain-picker-open');
      }
      open() {
        if (!this.dialog) {
          this.dialog = this.querySelector('[data-chain-template]').content.firstElementChild.cloneNode(true);
          document.body.appendChild(this.dialog);
          this.dialog.querySelector('[data-chain-close]').addEventListener('click', () => this.dialog.close());
          this.dialog.addEventListener('close', () => {
            document.documentElement.classList.remove('mellow-chain-picker-open');
            this.trigger.setAttribute('aria-expanded', 'false');
            this.trigger.focus({ preventScroll: true });
          });
          this.dialog.addEventListener('click', event => {
            if (event.target !== this.dialog) return;
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          });
          this.dialog.addEventListener('change', event => {
            if (event.target.matches('[data-chain-variant]')) this.updateCard(event.target.closest('[data-chain-card]'));
          });
          this.dialog.addEventListener('submit', event => this.addChain(event));
          this.dialog.querySelector('[data-chain-view-bag]').addEventListener('click', () => {
            this.dialog.close();
            const drawer = document.querySelector('[data-drawer="drawer-cart"]');
            if (drawer) drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
            else window.location.assign(this.dataset.cartUrl.replace(/\.js$/, ''));
          });
        }
        this.updateCharmImage();
        this.dialog.querySelectorAll('[data-chain-card]').forEach(card => {
          if (card.querySelector('[data-chain-form]').dataset.pending !== 'true') this.updateCard(card);
        });
        this.dialog.showModal();
        this.dialog.querySelector('.mellow-chain-dialog__body').scrollTop = 0;
        this.trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('mellow-chain-picker-open');
      }
      updateCharmImage() {
        const image = this.dialog?.querySelector('.mellow-chain-dialog__charm');
        const source = this.charmVariant?.featured_image?.src;
        if (image && source) {
          image.removeAttribute('srcset');
          image.src = source;
          image.alt = (this.charmVariant.featured_image.alt || '').split('#')[0].trim();
        }
      }
      updateCard(card) {
        const option = card.querySelector('[data-chain-variant]').selectedOptions[0];
        card.querySelector('[data-chain-price]').textContent = option.dataset.price;
        card.querySelector('[data-chain-price]').classList.toggle('is-sale', !!option.dataset.compare);
        const compare = card.querySelector('[data-chain-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
        card.querySelectorAll('[data-chain-link]').forEach(link => { link.href = option.dataset.url; });
        const image = card.querySelector('.mellow-chain-card__image img');
        if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
        const button = card.querySelector('[type="submit"]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? this.dataset.soldOutLabel : this.dataset.addLabel;
        card.querySelector('[data-chain-status]').textContent = '';
        card.querySelector('[data-chain-error]').textContent = '';
      }
      async addChain(event) {
        const form = event.target.closest('[data-chain-form]');
        if (!form) return;
        event.preventDefault();
        event.stopPropagation();
        if (form.dataset.pending === 'true') return;
        const select = form.querySelector('[data-chain-variant]');
        if (select.selectedOptions[0]?.dataset.available !== 'true') return;
        const body = new FormData(form);
        const button = form.querySelector('[type="submit"]');
        const status = form.querySelector('[data-chain-status]');
        const errorDisplay = form.querySelector('[data-chain-error]');
        form.dataset.pending = 'true';
        button.disabled = true;
        select.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = this.dataset.addingLabel;
        status.textContent = '';
        errorDisplay.textContent = '';
        let added = false;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || this.dataset.errorLabel);
          added = true;
          status.textContent = this.dataset.successLabel;
          button.textContent = this.dataset.addedLabel;
          try {
            const cartResponse = await fetch(this.dataset.cartUrl, { credentials: 'same-origin' });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
            }
          } catch (_) {}
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        } catch (error) {
          errorDisplay.textContent = error.message || this.dataset.errorLabel;
        } finally {
          form.dataset.pending = 'false';
          select.disabled = false;
          button.disabled = select.selectedOptions[0]?.dataset.available !== 'true';
          button.setAttribute('aria-busy', 'false');
          if (!added) button.textContent = this.dataset.addLabel;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mellow-product-social-proof"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (!root || root.dataset.productSocialProofReady === 'true') return;
      root.dataset.productSocialProofReady = 'true';

      const cards = Array.from(root.querySelectorAll('[data-product-social-video-card]'));

      const updateCard = (card, video) => {
        const isPlaying = !video.paused;
        const toggle = card.querySelector('[data-product-social-video-toggle]');
        card.classList.toggle('is-playing', isPlaying);
        if (toggle) toggle.disabled = isPlaying;
      };

      const toggleVideo = (video) => {
        if (video.paused) {
          cards.forEach((otherCard) => {
            const otherVideo = otherCard.querySelector('video');
            if (otherVideo && otherVideo !== video) otherVideo.pause();
          });
          video.muted = true;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      };

      cards.forEach((card) => {
        const video = card.querySelector('video');
        const toggle = card.querySelector('[data-product-social-video-toggle]');
        if (!video || !toggle) return;

        toggle.addEventListener('click', () => toggleVideo(video));
        video.addEventListener('click', () => toggleVideo(video));

        video.addEventListener('play', () => updateCard(card, video));
        video.addEventListener('pause', () => updateCard(card, video));
        video.addEventListener('ended', () => updateCard(card, video));
        updateCard(card, video);
      });

      const featuredVideo = cards[1]?.querySelector('video') || cards.find((card) => card.querySelector('video'))?.querySelector('video');
      if (featuredVideo) {
        featuredVideo.muted = true;
        featuredVideo.play().catch(() => {});
      }
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-mellow-product-social-proof]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
